import { render, staticRenderFns } from "./sendPoint.vue?vue&type=template&id=21ee14f7&scoped=true"
import script from "./sendPoint.vue?vue&type=script&lang=js"
export * from "./sendPoint.vue?vue&type=script&lang=js"
import style0 from "./sendPoint.vue?vue&type=style&index=0&id=21ee14f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee14f7",
  null
  
)

export default component.exports